"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = appendClassName;

function getNewClassName(newClassName) {
  if (!Array.isArray(newClassName)) return newClassName;
  return newClassName.filter(function (name) {
    return name;
  }).join(" ");
}

function appendClassName(baseClassName, newClassName) {
  if (!newClassName) return baseClassName || "";
  if (!baseClassName) return getNewClassName(newClassName) || "";
  return "".concat(baseClassName, " ").concat(getNewClassName(newClassName));
}